export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14671.1f10c3d6.jpg";